import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mailboxSelect", "localPartInput", "domainSuffix", "emailPreview"]
  static values = { domain: String }

  connect() {
    this.updateDomainSuffix()
  }

  updateDomainSuffix() {
    if (this.hasDomainValue && this.domainValue) {
      this.domainSuffixTarget.textContent = `@${this.domainValue}`
      this.updatePreview()
      return
    }

    if (!this.hasMailboxSelectTarget) {
      this.updatePreview()
      return
    }

    const mailboxId = this.mailboxSelectTarget.value
    const domainSpan = this.element.querySelector(`[data-mailbox-id="${mailboxId}"]`)
    const domain = domainSpan ? domainSpan.dataset.mailboxDomain : null

    if (domain) {
      this.domainSuffixTarget.textContent = `@${domain}`
    } else {
      this.domainSuffixTarget.textContent = "@…"
    }

    this.updatePreview()
  }

  updatePreview() {
    const localPart = this.localPartInputTarget.value.trim()
    const domain = this.domainSuffixTarget.textContent.replace(/^@/, "")

    if (localPart && domain && domain !== "…") {
      this.emailPreviewTarget.textContent = `→ ${localPart}@${domain}`
    } else {
      this.emailPreviewTarget.textContent = ""
    }
  }
}
